
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/receipt",
      function () {
        return require("private-next-pages/receipt/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/receipt"])
      });
    }
  